/** The style a scope's boxes open with by default, per channel. */
export interface OpenerChannelDefaults {
  /** The hosted storefront, the /v1 API and @loot-os/react embeds. */
  storefront: string;
  /** A Shopify shop's overlay. */
  shopify: string;
}

/** A badge the styles grid puts on a style something opens with by default. */
export interface OpenerDefaultBadge {
  styleId: string;
  label: string;
}

/** The one style both channels open with, or null when they differ and no single name is true. */
export function sharedOpenerDefault(defaults: OpenerChannelDefaults): string | null {
  return defaults.storefront === defaults.shopify ? defaults.storefront : null;
}

/** The default badges: one "Default" when both channels share a style, else one per channel. */
export function openerDefaultBadges(defaults: OpenerChannelDefaults): OpenerDefaultBadge[] {
  const shared = sharedOpenerDefault(defaults);
  if (shared !== null) return [{ styleId: shared, label: "Default" }];
  return [
    { styleId: defaults.storefront, label: "Storefront default" },
    { styleId: defaults.shopify, label: "Shopify default" },
  ];
}

/**
 * What an environment's boxes open with by default (`openerStyles.list`): its own style on both
 * channels, else the platform's default for each.
 */
export function environmentOpenerDefaults(list: {
  environmentStyleId: string | null;
  platformDefaultStyleId: string;
  platformShopifyDefaultStyleId: string;
}): OpenerChannelDefaults {
  return {
    storefront: list.environmentStyleId ?? list.platformDefaultStyleId,
    shopify: list.environmentStyleId ?? list.platformShopifyDefaultStyleId,
  };
}
